var _g, _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCollapseExpandIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7353_209646)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 8,
    width: 24,
    height: 24,
    rx: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.25,
    y: 8.25,
    width: 23.5,
    height: 23.5,
    rx: 5.75,
    stroke: "#F4F4F4",
    strokeWidth: 0.5
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.0244 19.4287H21.2148C21.3458 19.4287 21.2271 19.4287 21.2148 19.4287H15.9767C15.8131 19.4287 15.7148 19.5716 15.7148 19.7144V20.8573C15.7148 21.0359 15.8131 21.143 15.9767 21.143H21.2148C21.5177 21.143 21.354 21.143 21.5177 21.143H22.4998C22.7535 21.143 22.4916 21.143 22.7863 21.143H28.0244C28.1553 21.143 28.2863 21.0359 28.2863 20.8573V19.7144C28.2863 19.5716 28.1553 19.4287 28.0244 19.4287Z",
    fill: "#1752B0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0765 14.2713L21.1509 21.0804C21.1494 20.9495 21.1507 21.0681 21.1509 21.0804L21.2081 26.3182C21.2099 26.4819 21.3538 26.5785 21.4966 26.577L22.6394 26.5645C22.818 26.5625 22.924 26.4632 22.9223 26.2995L22.8651 21.0617C22.8618 20.7589 22.8635 20.9226 22.8618 20.7589L22.851 19.7768C22.8483 19.5231 22.8511 19.785 22.8479 19.4904L22.7907 14.2526C22.7893 14.1216 22.6807 13.9918 22.5021 13.9938L21.3594 14.0063C21.2165 14.0078 21.0751 14.1403 21.0765 14.2713Z",
    fill: "#1752B0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7353_209646",
    x: 0,
    y: 0,
    width: 44,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.176471 0 0 0 0 0.439216 0 0 0 0 0.85098 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7353_209646"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7353_209646",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapseExpandIcon);
export default __webpack_public_path__ + "static/media/CollapseExpandIcon.54e4c344178b7950cdc047fe3bc20760.svg";
export { ForwardRef as ReactComponent };